export default  [{
  path: '/seedlingList',
  name: 'seedlingList',
  component: () => import('@/views/setting/seedling/Base.vue'),
  redirect: '/seedlingList/list',
  children: [{
    name: 'seedlingList',
    path: '/seedlingList/list',
    component: () => import('@/views/setting/seedling/List.vue'),
    meta: {
      title: '普通苗木',
      hasBack: false
    }
  }, {
    path: '/seedlingList/map',
    name: 'seedlingMapList',
    component: () => import('@/views/setting/seedling/Map.vue'),
    meta: {
      title: '普通苗木',
      activeMenu: '/seedlingList/list',
      hasBack: false
    }
  }]
},
{
  path: '/seedlingList/add',
  name: 'seedlingAdd',
  meta: {
    title: '新增',
    activeMenu: '/seedlingList/list'
  },
  component: () => import('@/views/setting/seedling/Add.vue')
},
{
  path: '/seedlingList/update:seedlingId',
  name: 'seedlingUpdate',
  meta: {
    title: '编辑',
    activeMenu: '/seedlingList/list'
  },
  component: () => import('@/views/setting/seedling/Add.vue')
},
{
  path: '/seedlingList/list/detail:seedlingId',
  name: 'seedlingListDetail',
  component: () => import('@/views/setting/seedling/PlantDetail.vue'),
  meta: {
    title: '列表-详情',
    activeMenu: '/seedlingList/list'
  }
},
{
  path: '/seedlingList/map/detail:seedlingId',
  name: 'seedlingMapDetail',
  component: () => import('@/views/setting/seedling/PlantDetail.vue'),
  meta: {
    title: '地图-详情',
    activeMenu: '/seedlingList/list'
  }
}]
